import React from "react";
import { motion } from "framer-motion";
import { skillGroups } from "./constants";
import "../styles/About.css";

const aboutPoints = [
  "Software Engineer in Production Engineering at Egnyte, working across Platform, DevOps, and AI Infrastructure since Aug 2023.",
  "I operate 15+ production AI services across GCP, Azure, and on-prem: GPT services, embedding platforms, OCR pipelines, document classification, and Gemini/Claude-based workloads.",
  "KEDA autoscaling and GKE Compute Class migrations I drove saved $10K in one month, projecting $100K+ annual infrastructure reduction.",
  "Owned FedRAMP security remediation: 100+ CVEs patched across production VMs with SELinux and fapolicy hardening for ATO compliance.",
  "CS grad from Bipin Tripathi Kumaon Institute of Technology (2019–2023, CGPA 8.20).",
  "Before DevOps I was deep into competitive programming. 1000+ DSA problems solved, LeetCode Knight (top 2.1%), CodeChef 5 star.",
  "Into platform engineering or AI infra? Let's connect on LinkedIn.",
];

const currentFocus = [
  "Building LLM-based tooling with MCP servers and Claude/Augment Code",
  "LLM serving infra with SGLang and vLLM on GPU node pools",
  "GitOps at scale with ArgoCD",
  "Go for platform tooling",
];

function About() {
  return (
    <motion.div
      className="about__main page"
      variants={{
        hidden: { opacity: 0, x: 75 },
        visible: { opacity: 1, x: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">About Me</h1>
      <p className="page-subtitle">
        Platform / DevOps / AI Infrastructure Engineer @ Egnyte
      </p>

      <div className="about__elements">
        {aboutPoints.map((point, index) => (
          <div className="about__first" key={index}>
            <div className="abt__icon">
              <svg className="svg-icon" viewBox="0 0 20 20">
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
            <p>{point}</p>
          </div>
        ))}
      </div>

      <h2 className="section-heading">Technical Skills 👨‍💻</h2>
      <div className="skills__grid">
        {skillGroups.map((group) => (
          <div className="skills__card" key={group.category}>
            <h3>{group.category}</h3>
            <div className="skills__tags">
              {group.skills.map((skill) => (
                <span className="tag" key={skill}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <h2 className="section-heading">Currently Exploring 🚀</h2>
      <ul className="about__focus">
        {currentFocus.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </motion.div>
  );
}

export default About;
